import React from 'react';
import { useTranslation } from '../i18n';

export const FormLegend: React.FC = () => {
  const { t } = useTranslation();
  return <p className="form-legend">{t('forms.required_legend')}</p>;
};
